export default __webpack_public_path__ + "static/media/work4.ef3a0196.png";